import React from 'react';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import { AdditionalFolderAutomationDrawerForm } from './AdditionalFolderAutomationDrawerForm';

export const AdditionalFolderAutomationDrawer = ({ open, onClose }) => (
	<FolioDrawer open={open} onClose={onClose}>
		{open && <AdditionalFolderAutomationDrawerForm />}
	</FolioDrawer>
);

export default AdditionalFolderAutomationDrawer;
